import { createRoot } from "react-dom/client";
import "css/index.css";
import React, { Suspense } from "react";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { RecoilRoot } from "recoil";
import { Loading } from "components";

// dependency update
const root = createRoot(document.getElementById("root"));

root.render(<React.StrictMode>
  <BrowserRouter>
    <RecoilRoot>
      <Suspense fallback={<Loading />}>
        <App />
      </Suspense>
    </RecoilRoot>
  </BrowserRouter>
</React.StrictMode>);
